var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block",class:{'block-active': _vm.isActive},on:{"click":function($event){$event.stopPropagation();return _vm.handleClickBlock($event)}}},[_c('div',{staticClass:"block-slot"},[(_vm.label)?_c('span',{staticClass:"block-label",class:{'block-label-active' : _vm.isActive}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/box/box.vue